<template>
  <div
    v-for="attribute in filter.attributes"
    :id="`filter-number-${filter.key}-${attribute.key}`"
    :key="attribute.key"
    class="ml-3 flex flex-row gap-1"
  >
    <UiSwitch
      :id="`filter-number-${filter.key}-${attribute.key}`"
      :checked="!!value?.includes(attribute.key)"
      :label="attribute.label"
      @update:model-value="() => updateValue(filter.key, attribute.key)"
    />
    <UiCounter :id="`filter-number-${filter.key}-${attribute.key}`" :value="attribute.count ?? 0" />
  </div>
</template>

<script setup lang="ts">
import type { FilterProps } from '~/components/ProductList/Filters/types';

defineProps<FilterProps<string[], string>>();
</script>
